import { QueryClient } from "react-query";
import {
  restorePersistedQueryCache,
  setupQueryCachePersistence,
} from "./persistence";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: (failureCount, error) => {
        if (error?.response?.status === 401 || error?.response?.status === 403 || error?.response?.status === 404) {
          return false;
        }
        return failureCount < 2;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      keepPreviousData: true,
    },
    mutations: {
      retry: 1,
    },
  },
});

if (typeof window !== "undefined") {
  restorePersistedQueryCache(queryClient);
  setupQueryCachePersistence(queryClient);
}

export default queryClient;
